// @flow

import * as React from 'react';

import s from './RadioButton.scss';

type Props = {
  id: string|number,
  label: string,
  name: string,
  value: string|number,
  checked: boolean,
  onChange: (e: SyntheticEvent<any>) => void,
  disabled: boolean,
}

export const RadioButton = (props: Props) => {
  const { id, label, checked, onChange, disabled, name, value} = props;

  const disabledStyle = {
    cursor: 'not-allowed',
  }

  return (
    <div className={s.round}>
      <input
        checked={checked}
        onChange={e => onChange(e)}
        type="radio"
        value={value}
        name={name}
        disabled={disabled}
        {...props}
      />
      <label style={disabled ? disabledStyle: null} htmlFor={id}></label>
      <span className={s.label}>{label}</span>
    </div>
  )
}

export default RadioButton;
